'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import '@/lib/platform';
import { AuthDialogProvider } from './landing/AuthDialog';

export function Providers({
  children,
  authModalImage,
}: {
  children: ReactNode;
  authModalImage?: string | null;
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthDialogProvider authModalImage={authModalImage ?? null}>
        {children}
      </AuthDialogProvider>
    </QueryClientProvider>
  );
}
